export class EntWinterCerealFertilizerFilter {
  page: number = 1;
  size: number = 30;
  territorialUnitIds: number[] | null = null;
  cropTypeIds: number[] | null = null;
  periodStart: string | null = null;
  periodEnd: string | null = null;
  createdFrom: number | null = null;
  createdTo: number | null = null;
  deleted: boolean = false;
}
